GP.vent.on("user:finish_profile:cleanup", function(profile_num_left) {
    if (profile_num_left && profile_num_left > 0) {
        // set num left
        var progress_count = 13 - profile_num_left;
        $('#profile-num-left').text(progress_count);
        $('#mobile-sidebar .finish-profile-count').text(progress_count);
        $('#mobile-sidebar .finish-profile-progress').val(parseInt(progress_count, 10));


        // set progressbar in header
        var completed_width = (1 - (profile_num_left/13)) * 166;
        $('#finish-profile-progressbar .progress-completed').css('width', completed_width);
    } else {
        $('#nav-profile-link i').remove();
        $('#nav-profile-link').append('<b class="caret"></b>');
        $('#finish-profile').remove();
    }

    $.post('/members/user/finish_profile/', {'cache_regen':'true'});
});

GP.vent.on("user:finish_profile:done", function() {
    $(function() {
        $('#mobile-sidebar').find('#js-finish-profile-wrap').remove();
    });
});
